import { Link } from 'react-router-dom';
import { categories, games, articles } from '@/mocks/gameData';

export default function Home() {
  const hotGames = [...games].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 4);
  const topGames = [...games].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '黄油游戏大全 - 最全收录与推荐指南',
            description: '黄油游戏大全为您汇聚海量优质黄油游戏资源，涵盖各类型、各平台热门作品，提供详细评测、下载指引与玩家攻略。',
            url: 'https://hdyxdaquan.com/',
            isPartOf: { '@id': 'https://hdyxdaquan.com/#website' },
            about: { '@id': 'https://hdyxdaquan.com/#organization' },
          }),
        }}
      />

      {/* Hero */}
      <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20fantasy%20gaming%20collage%20with%20various%20game%20characters%20and%20magical%20landscapes%2C%20warm%20golden%20and%20amber%20lighting%2C%20dramatic%20composition%2C%20rich%20contrast%2C%20cinematic%20atmosphere%2C%20anime%20and%20fantasy%20art%20style%20blend&width=1920&height=900&seq=hero-bg-2025&orientation=landscape"
            alt="黄油游戏大全 - 最全收录与推荐指南"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 text-center pt-16">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
            黄油游戏大全
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚海量优质黄油游戏资源，涵盖各类型、各平台热门作品<br className="hidden sm:block" />
            提供详细评测、下载指引与玩家攻略，帮助您快速找到心仪的黄油游戏
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/rpg"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              浏览游戏分类
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/10 text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/20 transition-all whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-400">{games.length * 10}+</div>
              <div className="text-xs text-background-300 mt-1">收录游戏</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-400">{categories.length}</div>
              <div className="text-xs text-background-300 mt-1">游戏分类</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-400">{articles.length * 50}+</div>
              <div className="text-xs text-background-300 mt-1">精品攻略</div>
            </div>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">游戏分类</h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">按类别浏览，快速找到你感兴趣的游戏类型</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-xl p-5 text-center hover:bg-primary-500 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-background-50 mb-1 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-400 group-hover:text-background-50/70">{cat.count}款游戏</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Games */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">热门游戏</h2>
              <p className="text-sm text-foreground-500">玩家评分最高的精选游戏</p>
            </div>
            <Link to="/category/rpg" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
            {hotGames.map((game) => (
              <Link
                key={game.slug}
                to={`/article/${game.slug}`}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img src={game.imageUrl} alt={game.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-primary-600">
                    {categories.find(c => c.slug === game.category)?.name || game.category}
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-50/90 backdrop-blur-sm rounded-full">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs font-medium text-foreground-700">{game.rating}</span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{game.title}</h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{game.description}</p>
                  <div className="flex items-center flex-wrap gap-1.5">
                    {game.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">{tag}</span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Rankings */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">黄油游戏排行榜</h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">根据玩家评分与热度综合排名的黄油游戏榜单</p>
          </div>
          <div className="max-w-3xl mx-auto bg-background-50 rounded-xl border border-background-200 overflow-hidden">
            {topGames.map((game, index) => (
              <Link
                key={game.slug}
                to={`/article/${game.slug}`}
                className={`flex items-center gap-4 p-4 hover:bg-background-50/80 transition-colors cursor-pointer ${index < topGames.length - 1 ? 'border-b border-background-100' : ''}`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm flex-shrink-0 ${index < 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-600'}`}>
                  {index + 1}
                </div>
                <img src={game.thumbUrl} alt={game.title} className="w-16 h-10 rounded-lg object-cover flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">{game.title}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap overflow-hidden text-ellipsis">
                    {categories.find(c => c.slug === game.category)?.name} · {game.developer}
                  </p>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-sm font-medium text-foreground-700">{game.rating}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">最新攻略</h2>
              <p className="text-sm text-foreground-500">深度评测与实用攻略</p>
            </div>
            <Link to="/article/top-rpg-games-2025" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
              更多文章 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="h-40 overflow-hidden">
                  <img src={article.imageUrl} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                      {categories.find(c => c.slug === article.category)?.name}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">{article.title}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">常见问题</h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">关于黄油游戏大全的常见问题解答</p>
          </div>
          <div className="max-w-3xl mx-auto">
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'FAQPage',
                  mainEntity: [
                    { '@type': 'Question', name: '黄油游戏大全是什么？', acceptedAnswer: { '@type': 'Answer', text: '黄油游戏大全是一个专注于黄油游戏资源收录与推荐的中文导航平台，为玩家提供游戏分类浏览、详细评测攻略、排行榜以及下载指引。' } },
                    { '@type': 'Question', name: '如何找到适合自己的黄油游戏？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过网站的分类导航功能，按RPG、SLG、AVG、ACT等类型浏览游戏，也可以查看热门游戏排行榜和最新攻略文章来发现感兴趣的作品。' } },
                    { '@type': 'Question', name: '平台上的游戏评测靠谱吗？', acceptedAnswer: { '@type': 'Answer', text: '所有游戏评测均由资深玩家团队撰写，从剧情、玩法、美术、音乐等多个维度进行客观打分与详细分析，确保评测的专业性与公正性。' } },
                    { '@type': 'Question', name: '黄油游戏大全是否免费使用？', acceptedAnswer: { '@type': 'Answer', text: '是的，黄油游戏大全导航平台完全免费使用。您无需注册即可浏览全部游戏分类、查看文章攻略和游戏排行榜。' } },
                  ],
                }),
              }}
            />
            <div className="space-y-3">
              {[
                { q: '黄油游戏大全是什么？', a: '黄油游戏大全是一个专注于黄油游戏资源收录与推荐的中文导航平台，为玩家提供游戏分类浏览、详细评测攻略、排行榜以及下载指引。' },
                { q: '如何找到适合自己的黄油游戏？', a: '您可以通过网站的分类导航功能，按RPG、SLG、AVG、ACT等类型浏览游戏，也可以查看热门游戏排行榜和最新攻略文章来发现感兴趣的作品。' },
                { q: '平台上的游戏评测靠谱吗？', a: '所有游戏评测均由资深玩家团队撰写，从剧情、玩法、美术、音乐等多个维度进行客观打分与详细分析，确保评测的专业性与公正性。' },
                { q: '黄油游戏大全是否免费使用？', a: '是的，黄油游戏大全导航平台完全免费使用。您无需注册即可浏览全部游戏分类、查看文章攻略和游戏排行榜。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-xl border border-background-200">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-2xl mx-auto text-center bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-10 md:p-14">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">找到你的下一款心动游戏</h2>
            <p className="text-sm text-background-50/80 mb-8 max-w-md mx-auto">
              海量黄油游戏等你来探索，从经典到新作，从RPG到AVG，总有一款适合你
            </p>
            <Link to="/category/rpg" className="inline-flex px-8 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-all whitespace-nowrap">
              立即探索游戏
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}